import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
} from "@mui/material";

import InputDate from "@/components/form/InputDate";
import InputText from "@/components/form/InputText";

import { Control } from "react-hook-form";

interface EditExamDialogProps {
  open: boolean;
  onClose: () => void;
  control: Control<any>;
  editingIndex: number | null;
  onSave: () => void;
}

export const EditExamDialog = ({
  open,
  onClose,
  control,
  editingIndex,
  onSave,
}: EditExamDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Editar Exame</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Stack direction="row" spacing={2}>
            <InputText
              label="Valor"
              name={`newExames.${editingIndex}.value`}
              control={control}
              sx={{ flexGrow: 1 }}
            />
            <InputText
              label="Unidade"
              name={`newExames.${editingIndex}.unit`}
              control={control}
              sx={{ width: 120 }}
            />
          </Stack>
          <InputDate
            label="Data"
            name={`newExames.${editingIndex}.date`}
            control={control}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Fechar
        </Button>
        <Button onClick={onSave} variant="contained" color="primary">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
